import { makeProductEditingModalHtml } from '../../../../../Creator/Setting/S/product.tmpl.js';

export const makeProductWithPreDiscountEditingModalHtml = (transfer_data) => {
  return makeProductEditingModalHtml({
    ...transfer_data,
    is_pre_discount_product: true,
  });
};
